<template>
  <a
    :href="href"
    class="gh-button-call">
    <slot>
      <v-icon>phone</v-icon>  {{ phoneNumber }}
    </slot>
  </a>
</template>

<script>
export default {
  name: 'gh-button-call',

  props: {
    phoneNumber: {
      type: String,
      default: '07 3569 6800'
    }
  },

  computed: {
    href () {
      const number = this.phoneNumber

      return `tel:${number.replace(/\s/g, '')}`
    }
  }
}
</script>

<style lang="sass" scoped>
  .gh-button-call
    text-decoration: none

  .v-icon
    margin: 0 10px
</style>
